import { Component, Input, DoCheck } from '@angular/core';
import { ProductTagSource, ProductTagDef, PRODUCT_TAG_DEFS } from './product-tags.config';

/** 商品條件式標記（母/組 badge + 使用批號/不列入庫存 icon）共用元件 */
@Component({
  selector: 'app-stocks-product-tags',
  templateUrl: './product-tags.component.html',
  styleUrls: ['./product-tags.component.css']
})
export class ProductTagsComponent implements DoCheck {
  /** 商品來源物件（讀 StockType/ProductType/IsUseBatchNo/IsInventory） */
  @Input() product: ProductTagSource = null;

  /** 通過顯示條件的標記 */
  tags: ProductTagDef[] = [];

  /**
   * 上次計算 tags 時的欄位簽章。
   * 用 ngDoCheck（而非 ngOnChanges）：呼叫端常「就地修改」同一個 data 物件
   * （如選入商品時設定 detail.IsUseBatchNo），參考沒變不會觸發 ngOnChanges。
   * 以簽章比對偵測欄位變動，只有真的改變時才重算 filter，維持效能。
   */
  private lastSignature = '';

  ngDoCheck(): void {
    const p = this.product;
    const signature = p ? `${p.StockType}|${p.ProductType}|${p.IsUseBatchNo}|${p.IsInventory}` : '';
    if (signature !== this.lastSignature) {
      this.lastSignature = signature;
      this.tags = p ? PRODUCT_TAG_DEFS.filter(def => def.show(p)) : [];
    }
  }
}
